import plugin from '@ustra/nuxt/src/vue/plugins/client-init-plugin'

export default plugin
